/*
 * Copyright © 2021, CodeVision. All rights reserved.
 *
 * This file was generated by Codevision's stub generator
 */

export enum ServiceType {
  TYRE_REPLACEMENT = 0,
  AIR_CONDITIONER_CHARGING = 1,
  PUNCTURE_REPAIR = 2,
  SUSPENSION_ADJUSTMENT = 3,
  EXTRA_SERVICE = 4,
}

export namespace ServiceType {
  export function values() {
    return Object.keys(ServiceType).filter((type) => isNaN(type as any) && type !== 'values');
  }
}
